import { TableRowAction, TableActionIcon } from '@app/shared/models/table-action-type.model';
import { Subject, Observable } from 'rxjs';
import { ModalHelper } from '@app/shared/models/modal-helper.model';
import { ModalComponent } from '@app/shared/components/modal/modal.component';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministrationComponentHelper } from '@app/core/models/administration/administration-component-helper';
import { AdministrationConfigModel } from '@app/core/models/administration/administration-config.model';
import { ImportItemsComponent } from './import-items/import-items.component';
import { ImportReportModel } from '@app/core/models/administration/imports/import-report.model';
import { EventEmitter } from '@angular/core';
import { AuthenticationInfoService } from '@app/core/guards/authentication-info.service';
import { AccessRequirement } from '@app/core/models/access-requirement.model';

export abstract class AdministrationBase<TModel> {

    public dataItems: TModel[];

    public columnsDefinition = {};

    public tableIndications = {};

    public tableActions: TableRowAction[] = [];

    protected unsubscribe$: Subject<boolean> = new Subject<boolean>();

    private configuration: AdministrationConfigModel;

    public configKey: string;

    public exportFileName: string;

    public onExportExcelCaller: EventEmitter<void> = new EventEmitter<void>();
    public onFiltersCleared: EventEmitter<void> = new EventEmitter<void>();

    public title: string;
    public subtitle: string;
    public panelOpenState: boolean = true;

    public isAdministrator : boolean = false;
    public isReadOnly : boolean = false;

    constructor(
        public dialog: MatDialog,
        protected router: Router,
        protected route: ActivatedRoute,
        public authenticationInfoService: AuthenticationInfoService) {
        this.tableActions.push(new TableRowAction(TableActionIcon.ZOOM, 'Voir le détail', this.onZoom));
        this.route.data.subscribe(data => this.dataItems = data.dataItems);
        this.configKey = this.route.snapshot.data.configKey;
        this.configuration = new AdministrationComponentHelper().getConfiguration(this.configKey);
        this.columnsDefinition = this.configuration.tableColumns;
        this.exportFileName = this.configuration.exportFileName;

        this.isAdministrator = this.authenticationInfoService.authentificatedUser
        ? this.authenticationInfoService.authentificatedUser.hasGrant(
            AccessRequirement.AdministrationMembership
          )
        : false;
    }

    public onChangeStatus = (data: any) => {
        if ((data.IsActive && !data.CanBeDisabled) || (!data.IsActive && !data.CanBeEnabled)) {
            return;
        }

        const message = `Êtes-vous sûr de vouloir ${!data.IsActive ? 'activer' : 'désactiver'} ${this.configuration.partialMessageName} "${this.configuration.displayNameExtractor(data)}" ?`;
        const modalConfig = new ModalHelper().getConfirmationConfig(message);
        const dialog = this.dialog.open(ModalComponent, modalConfig);

        dialog.afterClosed()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(result => {
                if (result) {
                    if (!data.IsActive) {
                        this.activateItem(data.Id)
                            .pipe(takeUntil(this.unsubscribe$))
                            .subscribe(_ => data.IsActive = true);
                    } else {
                        this.deactivateItem(data.Id)
                            .pipe(takeUntil(this.unsubscribe$))
                            .subscribe(_ => data.IsActive = false,
                                err => {
                                    if (err.status === 403) {
                                        data.CanBeDisabled = false;
                                    }
                                });
                    }
                }
            });
    }

    protected abstract activateItem(id: any): Observable<any>;

    protected abstract deactivateItem(id: any): Observable<any>;

    protected abstract importHandler(files: File[]): Observable<ImportReportModel[]>;

    protected abstract getDataItems(): Observable<TModel[]>;

    protected onZoom = (model: any) => {
        this.InnerZoom(model);
    }

    protected InnerZoom(model: any): void {
        this.router.navigate([this.configuration.detailUrl, model.Id]);
    }

    public onNew = () => {
        this.router.navigate([this.configuration.newUrl]);
    }

    public onImport = () => {
        const modalConfig = new ModalHelper().getImportConfig(this.importHandler);
        const dialog = this.dialog.open(ImportItemsComponent, modalConfig);

        dialog.afterClosed()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(result => {
                if (result) {
                    this.getDataItems()
                        .pipe(takeUntil(this.unsubscribe$))
                        .subscribe((data: TModel[]) => {
                            this.onDataFetched(data);
                            this.dataItems = this.extractItemsFromData(data);
                        });
                }
            });
    }

    protected onDataFetched(data: any): void {
    }

    protected extractItemsFromData(data: any): TModel[] {
        return data;
    }

    onShowFilter(panelvalue:boolean) {
      this.panelOpenState = panelvalue;
    }
}
